import { FC } from 'react';

import { GraphQLQuery } from '../../types';
import styles from './GraphQLQueryVariables.module.css';

type Props = {
  query: GraphQLQuery;
};

const GraphQLQueryVariables: FC<Props> = ({ query }) => {
  const body = query.request.body?.toString();

  if (!body) return null;

  const json = JSON.parse(body);

  return (
    <pre className={styles.root}>
      {JSON.stringify(json.variables, undefined, 2)}
    </pre>
  );
};

export default GraphQLQueryVariables;
